import { Button, Row } from "antd";
import { Link } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableProjects from "../../components/tables/TableProjects/TableProjects";
import { useLazyFetchPaginatedProjectsQuery } from "../../features/api/apiSlice";

const PagePdcaProjets: React.FC = () => {
  const [fetchProjects, { data, isFetching }] =
    useLazyFetchPaginatedProjectsQuery();

  return (
    <PageLayout>
      <Row justify="space-between" align="middle">
        <h1>PDCA - Projets</h1>
        <Link to="/projects/new">
          <Button type="primary">CrÃ©er un projet</Button>
        </Link>
      </Row>
      <Row>
        <TableProjects data={data} fetchData={fetchProjects} isLoading={isFetching} />
      </Row>
    </PageLayout>
  );
};

export default PagePdcaProjets;
